module.exports = __webpack_public_path__ + "img/pen-suit (1).6c31a71d.png";